import { ApiRequestFilters } from '../../../shared/types/api-request-filters';

/**
 * Agent categories filters
 */
export class AgentCategoriesFilters extends ApiRequestFilters {}
